export const CONFIG = Object.freeze({
  env: process.env.NODE_ENV,
  baseUrl: process.env.REACT_APP_BASE_URL,
  gauthClientId: process.env.REACT_APP_GAUTH_CLIENT_ID,
  appEnv: process.env.REACT_APP_ENV,
  gauthOAuth: process.env.REACT_APP_GOOGLE_OAUTH2,
  redirectUrl: process.env.REACT_APP_REDIRECT_URL,
  moderatorUrl: process.env.REACT_APP_MODERATOR_URL,
  chatUrl: process.env.REACT_APP_CHAT_URL,
  // Public web app origin — used to build shareable /v/:uuid and /offers/:uuid links.
  webUrl: process.env.REACT_APP_WEB_URL || 'http://localhost:3000',
})